export enum FlightRequestSourceEnum {
  RTP = 'RTP',
  AVINODE = 'Avinode',
  STAFF_CREATED = 'Staff Created',
  ELAC = 'ELAC',
}